import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=cde734f4&scoped=true&"
import script from "./Event.vue?vue&type=script&lang=js&"
export * from "./Event.vue?vue&type=script&lang=js&"
import style0 from "./Event.vue?vue&type=style&index=0&id=cde734f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde734f4",
  null
  
)

export default component.exports